import Icon from '@material-ui/icons/HelpOutline';
import QuarantineList from './QuarantineList'

export default {
    list: QuarantineList,
    //edit: ShipmentEdit,
    //create: DonorCreate,
    icon: Icon,
};
